import PageShell from "@/components/site/PageShell";
import PageHero from "@/components/site/PageHero";
import BookingCTA from "@/components/home/BookingCTA";
import LazyImage from "@/components/site/LazyImage";
import { CAMPFIRE } from "@/data/content";

export default function Campfire() {
  return (
    <PageShell testId="campfire-page">
      <PageHero
        overline="Evenings · Bonfire"
        title={["Campfire &", "Bonfire Nights"]}
        subtitle="Stories, warmth and a sky full of stars, deep in the Western Ghats."
        image={CAMPFIRE.images[0]}
      />

      <section className="bg-ivory py-12 md:py-16">
        <div className="mx-auto max-w-4xl px-5 text-center md:px-10">
          <h2 className="font-display text-4xl font-bold leading-tight tracking-tight text-forest sm:text-5xl md:text-6xl">
            Gather around the fire in Kalasa
          </h2>
          <p className="mt-7 text-lg text-charcoal/70">{CAMPFIRE.intro}</p>
        </div>

        <div className="mx-auto mt-14 max-w-[1400px] px-5 md:px-10">
          <LazyImage src={CAMPFIRE.images[0]} alt="Bonfire night" fit="cover" className="aspect-video rounded-2xl" />
        </div>

        <div className="mx-auto mt-16 grid max-w-[1400px] items-center gap-10 px-5 md:grid-cols-2 md:gap-16 md:px-10">
          <div>
            <p className="mb-4 text-sm uppercase tracking-widest-2 text-brown md:text-base">Made For Togetherness</p>
            <h3 className="font-display text-3xl font-bold text-forest md:text-4xl">Best for couples, friends &amp; families</h3>
            <p className="mt-5 text-charcoal/70">{CAMPFIRE.moreWords}</p>
          </div>
          <LazyImage src={CAMPFIRE.images[1]} alt="Campfire in the forest" fit="cover" className="aspect-video rounded-2xl" />
        </div>
      </section>

      <BookingCTA />
    </PageShell>
  );
}
